import React from 'react'
import styled from 'styled-components'
import { Col, Container, Row } from 'react-bootstrap'
import { Box, LazyImage, MainHeading, TextStyled, HeadingStyled, SpanStyled } from '../../../ui/Elements'
import { ArrowBtn, ArrowBtnBrown, CheckSuccess, HeroBg, HeroBgAr, IconBg, IconBg2, InvoiceImg, InvoiceImgAr, Lights, QuotationArrow, QuotationImg, QuotationImg1, QuotationImgAr, Sofa, TransformBg } from '../../../ui/AllImages'
import { useTranslation } from 'react-i18next'
import { ContactButton } from '../../../ui/CustomElements'
import { BenefitsList1 } from '../../projectData/Data'
// import ServicesBlocks from './benefitsContent/BenefitsBlocks'
import i18n from '../../../Languages/INEXT'
const Qutation = () => {
    const { t } = useTranslation();
    const WhatsApp = () => {
        const phoneNumber = '+966567974344';
        const message = 'Hello, this is  Soola';
        const whatsappURL = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
        window.open(whatsappURL, '_blank');
    };
    return (
        <>
            <QutationWapper className='container-fluid common-space qutationFluid' id="quotation">
                <Container>
                    <Box className='quotationRow row'>
                        <Col md={12} className="quotationColMain headingColMain">
                            <Box className='quotationDescCol1Content'>
                                <MainHeading className='main-heading mb-1 quotationMH text-center'>
                                    {t('fromQuotationToInvoice')}  
                                </MainHeading>
                                <SpanStyled className='d-flex mb-4 quotationTxt text-center' size="18px">
                                    {t('turnApprovalsIntoPayments')}
                                </SpanStyled>
                            </Box>
                            
                            
                        </Col>
                        <Col md={12} className="quotationColBlocks">
                            <Box className='quotationGridCol'>
                                <Box className='quotationImgCol d-flex justify-content-center'>
                                    <MainHeading className='main-heading mb-2 quotationMHInner text-center' size="24px">
                                        {t('approvedQuotation')}  
                                    </MainHeading>
                                    <Box className='quteImg'>
                                        {i18n.language === "en" ? <img src={QuotationImg} alt="Invoice" /> : <img src={QuotationImgAr} alt="Invoice" />}
                                        
                                        
                                    </Box>
                                </Box>
                                <Box className='quteArrow'>
                                    <img src={QuotationArrow} alt='arrow' />
                                </Box>
                                <Box className='quotationImgCol'>
                                    <Box className='d-flex gap-3 justify-content-center quotationHeCh'>
                                        <Box><CheckSuccess /></Box>
                                        <MainHeading className='main-heading mb-2 quotationMHInner text-center' size="24px">
                                            {t('convertedSuccessfully')}  
                                        </MainHeading>
                                    </Box>
                                    
                                    <Box className='quteImg'>
                                        {i18n.language === "en" ? <img src={InvoiceImg} alt="Invoice" /> : <img src={InvoiceImgAr} alt="Invoice" />}
                                    </Box>
                                </Box>
                            </Box>
                            {/* <ServicesBlocks /> */}
                        </Col>
                    </Box>
                </Container>
            </QutationWapper>
        </>
    )
}
const QutationWapper = styled.section`
    /* padding-bottom: 0; */
    
    .quotationColMain{
        display: flex;
        justify-content: center;
        width: 100%;
        padding-left: 220px;
        padding-right: 220px;
        margin-bottom: 40px;
    }
    
    .quotationRow{
        /* margin-left: 0;
        margin-right: 0; */
    }
    
    .quotationDescCol1Content{
        display: inline-block;
        
    }
    .servicesDescCol2{
        display: flex;
        justify-content: center;
        padding-left: 200px;
        .servicesDescCol2Content{
            display: inline-block;
            width: 320px;
        }
    }
    .quotationColBlocks{
        display: flex;
        width: 100%;
        justify-content: center;
    }
    .quotationImgCol{
        display: flex;
        flex-wrap: wrap;
        width: 480px;
        justify-content: center;
    }

    .quteImg{
        width: 100%;
    }
    .quotationGridCol{
        display: flex;
        align-items: center;
        gap: 20px;
    }
    
    body.rtl &{
        & > .container{
            
            .servicesIH{
                font-size: 28px
            }
            .servicesDescCol2 {
                padding-left: 0;
                padding-right: 200px;
            }
            /* .quotationDescCol1Content {
                max-width: 490px;
            } */
            
        }
        .quotationMHInner{
            font-size: 22px;
        }
        /* .quotationMH{
            font-size: 24px;
        } */
        .quteArrow{
            img{
                -webkit-transform: scaleX(-1) !important;
                -moz-transform: scaleX(-1) !important;
                -o-transform: scaleX(-1) !important;
                transform: scaleX(-1) !important;
            }
        }
    }
    
    @media (max-width: 1399px) {
        
    }
    @media (max-width: 1299px) {
        & > .container{
            
        }
        body.rtl &{
            & > .container{
                
                
            }
        }
    }
    @media (max-width: 1199px) {
        .quotationImgCol{
            width: 430px;
        }
        & > .container{
            
            
        }
        body.rtl &{
            & > .container{
                .lights {
                    left: 32%;
                }
                
            }
        }
    }
    @media (max-width: 1099px) {
        &.qutationFluid{
            padding-bottom: 60px ;
        }
        .quotationImgCol{
            width: 380px;
        }
    }
     
    @media (max-width: 991px) {

        & > .container{
            .servicesDescCol{
                padding: 0;
                
            }
           
            .quotationDescCol1Content {
                max-width: 100%;
            }
            .servicesDescCol1{
                justify-content: flex-start;
                margin-bottom: 10px;
            }
            .servicesDescCol2{
                .servicesDescCol2Content{
                    width: 100%;
                }
            } 
            
            
        }
        .quotationGridCol{
            gap: 15px;
        }
        .quotationImgCol{
            width: 330px;
        }
        .quteArrow img{
            width: 50px;
        }
        body.rtl &{
            & > .container{
                .quotationDescCol1Content {
                    max-width: 100%;
                }
                .servicesDescCol2 {
                    padding-left: 0;
                    padding-right: 0;
                }
                
                .servicesIH{
                    font-size: 24px;
                }
            }
        }
    }
    @media (max-width: 767px) {
        & > .container{
            
            .servicesIH{
                font-size: 24px;
            }
            .transformTxt{
                font-size: 18px;
            }
            
        }
        .quotationGridCol{
            flex-wrap: wrap;
            justify-content: center;
        }
        .quotationImgCol {
            width: 100%;
            & *{
                justify-content: center;
                text-align: center;
            }
        }
        body & {
            .quteArrow{
                height: 87px;
                padding-top: 30px;
                img{
                    transform: rotate(90deg) !important;
                    width: 87px;
                }
            }
        }

        
        body.rtl &{
            & > .container{
                
                .servicesIH{
                    font-size: 24px;
                }
                .transformTxt{
                    font-size: 18px;
                }
                .quteArrow{
                    img{
                        transform: rotate(90deg) !important;
                    }
                }
                
            }
        }
    }
    @media (max-width: 640px) {
       
    }
    @media (max-width: 575px) {
        .quotationMHInner {
            font-size: 20px;
            margin-bottom: 0 !important;
        }
        .quotationHeCh{
            gap: 5px !important;
            align-items: center;
        }
        body.rtl &{
            .quotationMHInner {
                font-size: 20px;
            }
        }

    }
    @media (max-width: 350px) {
        
    }
`
export default Qutation
